var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPasswordShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x33_2x32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-576 220 32 32",
    style: {
      enableBackground: "new -576 220 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#AFB3BA;stroke-width:1.2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON-show"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2743_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2745_",
    className: "st0",
    d: "M-560,243.2c-5.2,0-8.8-3.7-10.5-7.2c1.7-3.6,5.2-7.2,10.5-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2744_",
    className: "st0",
    d: "M-560,243.2c5.2,0,8.8-3.7,10.5-7.2c-1.7-3.6-5.2-7.2-10.5-7.2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2742_",
    className: "st0",
    cx: -560,
    cy: 236,
    r: 4.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordShow);
export default __webpack_public_path__ + "static/media/ICON-password-show.2c260a5ebf2f72361f0ffa71e43d6798.svg";
export { ForwardRef as ReactComponent };